import iqosBleService from '../ble/iqosBleService';
import iqosHidService from '../hid/iqosHidService';
import connectivityService from './connectivityService';

export default class IqosServiceClient {
    constructor() {
        return connectivityService.isUsb() ? iqosHidService : iqosBleService;
    }
}
